export enum UserGroupType {
    Group = 1,
    User = 2,
    Client = 3
}
